module.exports = __webpack_public_path__ + "static/media/dost_for_ever.bb01a11f.gif";